import { controlador, urlBase } from 'constants/urls';

export const ConfirmarPagoOnlineConstant = {
  urls: {
    indicacionesGenerales: `${urlBase}${controlador}api/v1/pago/indicaciones-generales`,
    iniciarSesionPago: `${urlBase}${controlador}api/v1/pago/iniciar-sesion-pago`,
  },
};
